module.exports = __webpack_public_path__ + "static/media/59229.b127d68b.jpg";